import { CircularProgress, ListItem, ListItemText } from '@material-ui/core';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import React from 'react';
import { UploadingFileWithOptions } from '../SessionImagesFileUpload/SessionImagesFileUpload.types';

export const SessionImagesFileUploadItem: React.FC<UploadingFileWithOptions> = ({ file, error }) => {
  return (
    <>
      <ListItem key={file.name}>
        <div>
          <div style={{ display: 'inline-flex', margin: '0' }}>
            {!file.isUploading && (
              <CircularProgress color="inherit" style={{ height: '20px', width: '20px', color: 'grey' }} />
            )}
            {file.isUploading && error && <CancelIcon style={{ color: 'red' }} />}
            {file.isUploading && !file.error && <CheckCircleIcon style={{ color: 'green' }} />}

            <ListItemText primary={file.name} style={{ marginLeft: '10px' }} />
          </div>
          {file.isUploading && error && (
            <p style={{ color: 'red', fontSize: '0.8em', marginTop: '0', marginLeft: '35px', fontFamily: 'Roboto' }}>
              {file.error.info}
            </p>
          )}
        </div>
      </ListItem>
    </>
  );
};
